import React from 'react';
import PropTypes from 'prop-types';

import PersonImg from 'inside-out/images/medicare/person-1.png';

import {
	innerWrapperStyle,
	wrapperStyle,
	titleStyle,
	textStyle,
  resourceWrapper,
} from 'inside-out/page-styles/medicare';

import {
	contentSection,
} from 'inside-out/global-styles';

import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard'

const MedicareForHealthProfessionalsStep3Page = () => (
  <div className={wrapperStyle}>
    <section className={contentSection()}>
      <div className={innerWrapperStyle}>
          <h1 className={titleStyle}>Formal Specialist and Practitioner Review</h1>
          <div className={textStyle}>
            <p>90266-90269 (continue beyond 20 EDPT services)</p>

            <p>A patient must have two additional reviews before they can access more than 20 EDP psychological services. A psychiatrist or paediatritian must assess the patient and provide a report confirming the diagnosis at the initiation of the EDP, evaluate treatment progress and make a recommendation as to whether or not further psychological sessions are needed.</p>

            <p>We suggest that the mental health provider who has been delivering the psychological sessions, and if relevant the dietitian, provide a written report to both the psychiatrist/paediatritian and the GP prior to their reviews to make the case for further treatment if it is needed.</p>

            <p>The treating dietitian provides an end of treatment letter to the GP at or before Session 20.</p>
          </div>
      </div>
    </section>

    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle} style={{display: 'flex' }}>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/psychological-treatment-review-template' }
            audiences={ [] }
            title={ 'Psychological Treatment Review Template' }
            body={ 'The psychological treatment provider can use this template for a report back to the medical practitioner prior to care plan reviews at or before session 10, 20 and 30' }
            date={ '1 Nov, 2019' }
          />
        </div>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/dietetic-end-of-treatment-report-template' }
            audiences={ [] }
            title={ 'Dietetic End of Treatment Report Template' }
            body={ 'The dietitian can use this template for a report back to the medical practitioner following the completion of treatment under the Eating Disorder Care Plan whether this occurs at or before 20 sessions.' }
            date={ '1 Nov, 2019' }
          />
        </div>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/the-specialist-review' }
            audiences={ [] }
            title={ 'The Specialist Report' }
            body={ 'Summary of the formal specialist review by a consultant paediatrician or a consultant psychiatrist required to continue beyond 20 EDPT services.' }
            date={ '1 Nov, 2019' }
          />
        </div>
        <div className={resourceWrapper}>
          <ResourceCard
            background={ null }
            to={ '/resource-library/gp-care-plan-review-template' }
            audiences={ [] }
            title={ 'GP Care Plan Review Template' }
            body={ 'The medical practitioner can use this template to complete the Eating Disorder Care Plan Review at session 10, 20 and 30.' }
            date={ '1 Nov, 2019' }
          />
        </div>
      </div>
    </section>
  </div>
);

export { MedicareForHealthProfessionalsStep3Page }



// WEBPACK FOOTER //
// ./src/components/medicare/for-health-professionals/step-3.js